<template>
  <div class="ml-2">
    <v-menu offset-y nudge-bottom="8">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on" class="text-none d-flex align-center px-2" height="44">
          <span class="lang-code">{{ currentLocale.toUpperCase() }}</span>
          <l-icon small class="ml-1">mdi-chevron-down</l-icon>
        </v-btn>
      </template>
      <v-list dense max-height="320" style="overflow-y: auto">
        <v-list-item
          v-for="lang in languages"
          :key="lang.code"
          @click="changeLanguage(lang.code)"
          :class="{ 'primary--text': lang.code === currentLocale }"
        >
          <v-list-item-title class="text-body-2">{{ lang.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { SUPPORTED } from '@/i18n';

const LANG_NAMES = {
  ca: 'Català', cs: 'Čeština', da: 'Dansk', de: 'Deutsch', el: 'Ελληνικά',
  en: 'English', es: 'Español', fi: 'Suomi', fr: 'Français', hu: 'Magyar',
  it: 'Italiano', nl: 'Nederlands', no: 'Norsk', pl: 'Polski', pt: 'Português',
  ro: 'Română', ru: 'Русский', sv: 'Svenska', uk: 'Українська',
};

export default {
  name: 'LanguageSelector',
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    languages() {
      return SUPPORTED.map((code) => ({ code, name: LANG_NAMES[code] || code }));
    },
  },
  methods: {
    changeLanguage(code) {
      if (code === this.currentLocale) return;
      this.$cookies.set('language', code, '365d');
      // Set the locale first so the router's auto-prefix logic targets it.
      this.$i18n.locale = code;
      document.documentElement.lang = code;
      const target = this.localizedPath(code);
      if (this.$route.fullPath !== target) this.$router.push(target);
      this.$emit('language-changed', code);
    },
    localizedPath(code) {
      const segments = this.$route.path.split('/').filter(Boolean);
      if (segments.length && SUPPORTED.includes(segments[0])) segments.shift();
      const rest = segments.join('/');
      const base = code === 'en' ? '' : `/${code}`;
      const path = rest ? `${base}/${rest}` : (base || '/');
      return `${path}${this.$route.hash || ''}`;
    },
  },
};
</script>

<style scoped>
.lang-code {
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.05em;
}
</style>
